import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import AdminPanel from './pages/AdminPanel/AdminPanel';
import UserPanel from './pages/UserPanel/UserPanel';
import Timeline from './pages/Timeline';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import DonationPage from './pages/DonationPage';
import TimelinesPage from './pages/TimelinesPage';
import TimelineMapPage from './pages/TimelineMapPage';
import { useAuth } from './context/AuthContext';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/giris" />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/giris" element={<LoginPage />} />
          <Route path="/kayit" element={<RegisterPage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          <Route path="/bagis" element={<DonationPage />} />
          <Route path="/cizelgeler" element={<TimelinesPage />} />
          
          {/* Protected Routes */}
          <Route
            path="/gosterge-paneli"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/yonetim"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hesabim"
            element={
              <ProtectedRoute>
                <UserPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cizelge/:id"
            element={<Timeline />}
          />
          <Route
            path="/cizelge/:id/harita"
            element={<TimelineMapPage />}
          />
          
          {/* Catch all - redirect to home */}
          <Route
            path="*"
            element={
              <Navigate to="/" replace />
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
